/**
 * Вид, в котором отдаётся поисковый блок. Хост переключает его на лету через рантайм-API
 * `/v1/set-view` — например, когда на выдаче поисковая строка уезжает в шапку и на её месте
 * должна остаться компактная кнопка.
 */
export enum ESearchBlockView {
  /** Полноценная поисковая строка с плейсхолдером и кнопкой фильтров. */
  SearchString = 'searchString',
  /** Компактная кнопка с иконкой поиска. */
  Button = 'button',
}

export function isSearchBlockView(value: unknown): value is ESearchBlockView {
  return Object.values(ESearchBlockView).includes(value as ESearchBlockView);
}
